// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 143 ? "app" : chunkId) + "." + {"143":"dbaf96e558ea4d4d9166","348":"097a7b52d0ad996ef2ea"}[chunkId] + ".css";
};